import React, { useState } from 'react'
import SmsOptInCommonComponent from '@pcln/sms-opt-in'
import { Card, Link } from 'pcln-design-system'
import useGetDisclaimer from '@/components/SmsOptIn/useGetDisclaimer'
import useBootstrapData from '@/hooks/useBootstrapData'
import LayoutComponentWrapper from '@/components/LayoutComponentWrapper'
import { handleSubmit } from './utils'
import type { DisclaimerParams, SmsPhone } from './types'

const imageUrl =
  'https://s1.pclncdn.com/design-assets/brand-assets/business-man-in-car.jpg?opto&auto=avif,webp&dpr=2&orient=2&width=256&crop=3:2,smart'
const altImageText = 'business man in car'
const smallImageUrl =
  'https://s1.pclncdn.com/design-assets/brand-assets/business-man-in-car.jpg?opto&auto=avif,webp&dpr=2&orient=2&width=256&crop=2:3,smart'
const smallImageAltText = 'business man in car'
const headline = 'NEW: Get savings texted to you directly!'
const subheadline = `Provide your phone number and we'll send you special deals and promotions via SMS.`

export default function SmsOptIn({
  disclaimerQueryArgs
}: {
  disclaimerQueryArgs: DisclaimerParams
}) {
  const { appName, appVersion } = useBootstrapData()
  const disclaimers = useGetDisclaimer(disclaimerQueryArgs)
  const baseParams = disclaimerQueryArgs.disclaimerParams
  const [signUpState, setSignUpState] = useState('NOT_SIGNED_UP')
  const [signUpSubmitFailureMessage, setSignUpSubmitFailureMessage] =
    useState<string>('')

  const validDisclaimer = disclaimers.find(
    disclaimer => !disclaimer.optinStatus
  )

  const disclaimerText =
    validDisclaimer?.disclaimerText?.reduce(
      (previousValue, currentValue) =>
        previousValue + (currentValue ? currentValue.text : ''),
      ''
    ) ?? ''

  const disclaimerTextNode = (
    <>
      {validDisclaimer?.disclaimerText?.reduce<React.ReactElement[]>(
        (previousValue, currentValue, index) => {
          const uniqueKey = `${baseParams.disclaimerBaseParam.appCode}${index}`
          if (currentValue) {
            const { text, url } = currentValue
            previousValue.push(
              url ? (
                <Link href={url} target="blank" key={uniqueKey}>
                  {text}
                </Link>
              ) : (
                <span key={uniqueKey}>{text}</span>
              )
            )
          }
          return previousValue
        },
        [] as React.ReactElement[]
      )}
    </>
  )

  return (
    <>
      {validDisclaimer && (
        <LayoutComponentWrapper>
          <Card borderRadius="xl" p={4} mb={[2, 0, 4]}>
            <SmsOptInCommonComponent
              headline={headline}
              subheadline={subheadline}
              imageUrl={imageUrl}
              smallImageUrl={smallImageUrl}
              buttonSize="large"
              textInputRadius="lg"
              signUpState={signUpState}
              imageWidth={1 / 3}
              formWidth={2 / 3}
              disclaimerTextNode={disclaimerTextNode}
              handleFormSubmit={(formData: SmsPhone) =>
                handleSubmit({
                  appName,
                  appVersion,
                  formData,
                  disclaimerText,
                  baseParams,
                  setSignUpState,
                  setSignUpSubmitFailureMessage,
                  cguid: disclaimerQueryArgs.cguid
                })
              }
              phoneInputErrorMessage={signUpSubmitFailureMessage}
              altImageText={altImageText}
              smallImageAltText={smallImageAltText}
            />
          </Card>
        </LayoutComponentWrapper>
      )}
    </>
  )
}
